// extracted by mini-css-extract-plugin
export var circle = "_as-1";
export var exitConfirmationModal = "_as-5";
export var iframe = "_as-0";
export var offline = "_as-3";
export var online = "_as-2";
export var workstationSelectError = "_as-4";